import type StoreSchema from './StoreSchema';
import { createStore } from 'owa-satcheljs';
import { type BookingsRoute } from 'bookingsv2-constants/lib/bookingsRouteConstants';

const defaultSchemaStore: StoreSchema = {
    currentRoute: '',
    isRouteChangeFirstInSession: true,
    isBusinessInfoDirty: false,
    isBookingsPageDirty: false,
    isCustomFieldsPageDirty: false,
};

const initialStore = { ...defaultSchemaStore };
export const getBookingsRouterStore: () => StoreSchema = createStore<StoreSchema>(
    'BookingsRouterStorev2',
    initialStore
);
